import { styled } from '@mui/material'

export const Container = styled('div', {
  shouldForwardProp: (props) => props !== 'isSmallScreen',
})<{
  isSmallScreen?: boolean
}>`
  display: flex;
  justify-content: center;
  padding: ${({ theme, isSmallScreen }) => theme.spacing(2, 2, isSmallScreen ? 0.5 : 8, 2)};
`
